import { Gift } from 'lucide-react';

/**
 * Der Griff für den Geschenkwunsch (A30.1).
 *
 * WARUM ER HIER SITZT UND NICHT AM MERKZEICHEN
 *   Das Merkzeichen im Kopf erscheint nur, WENN der Wunsch gesetzt ist.
 *   Es kann deshalb nicht der Weg sein, ihn zu setzen — der wichtige
 *   Fall ist ja gerade „jemand hat es beim Aufnehmen vergessen", und da
 *   steht kein Merkzeichen. Der Griff gehört dorthin, wo die übrigen
 *   änderbaren Angaben der Bestellung schon sitzen: in die Reihe unter
 *   dem Kopf, neben Zustand, Versandart, Termin und Wiedervorlage.
 *
 *   Damit gilt für ihn dieselbe Regel wie für seine Nachbarn: Er steht
 *   da, ob der Wert gesetzt ist oder nicht, und sagt in beiden Fällen,
 *   was gerade gilt.
 *
 * KEINE RÜCKFRAGE
 *   Es ist eine Angabe, kein Vorgang, und sofort wieder umschaltbar. Ein
 *   Bestätigungsdialog für ein Häkchen ist Ballast.
 *
 * `aria-pressed` statt eines Kästchens: Der Knopf trägt seinen Zustand
 * selbst, und die Reihe daneben besteht ebenfalls aus Knöpfen — ein
 * einzelnes Kontrollkästchen mittendrin wäre ein Fremdkörper.
 */
export function GeschenkSchalter({
  wert,
  onChange
}: {
  wert: boolean;
  onChange: (neu: boolean) => void;
}) {
  return (
    <button
      type="button"
      data-nutzung="geschenk"
      aria-pressed={wert}
      onClick={() => onChange(!wert)}
      className={
        'inline-flex min-h-[44px] items-center gap-1.5 text-sm transition-colors ' +
        (wert ? 'text-ink hover:text-akzent' : 'text-ink-soft hover:text-akzent')
      }
      title={
        wert
          ? 'Bei der Aufnahme als Geschenk gewünscht — antippen, um es zurückzunehmen'
          : 'Kein Geschenkwunsch — antippen, um ihn nachzutragen'
      }
    >
      <Gift aria-hidden className={'h-4 w-4 shrink-0 ' + (wert ? 'text-gold-dark' : '')} />
      {wert ? 'Geschenk' : 'Kein Geschenk'}
    </button>
  );
}
